<script>
import { mapActions } from 'vuex';
import BaseSelectFilter from '@/modules/_global/_components/filters/BaseSelectFilter';

export default {
  name: 'ListsFilter',

  extends: BaseSelectFilter,

  methods: {
    ...mapActions('documents_lists', ['getFilteredLists']),
    getData() {
      return this.getFilteredLists()
        .then(({ data }) => {
          return data.data;
        })
        .catch(console.error);
    }
  }
};
</script>
